<template>
  <Tabs :links="tabLinks" :settings="settings">
    <div class="white-bg">
      <div class="table-heading flex flex-v-center flex-h-bet mb-20">
        <div class="flex">
          <div class="media-group flex filter-label  p-0">
            <div class="filter"><p class="ml-10">Filters:</p></div>
            <el-date-picker
              v-model="filterDate"
              type="date"
              placeholder="Select date(s)"
              class="no-border-date-picker"
            >
            </el-date-picker>
          </div>

          <el-select
            v-model="value"
            placeholder="All Status"
            class="filter-select ml-10"
            clearable
          >
            <el-option
              v-for="item in []"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="flex">
          <div class="relative">
            <img
              src="/img/search-icon.svg"
              alt="search team table"
              class="search-icon"
            />
            <el-input
              placeholder="Search"
              name="search"
              type="text"
              class="short mr-10"
              v-model="searchQuery"
              @input="search"
              clearable
            ></el-input>
          </div>
        </div>
      </div>
      <AllApprovalsLogsTable :data="tableData" />
    </div>
  </Tabs>
</template>

<script>
import AllApprovalsLogsTable from "../components/AllApprovalsLogsTable.vue";
import Tabs from "@/components/general/Tabs";
export default {
  data() {
    return {
      searchQuery: "",
      filterDate: "",
      value: "",
      tableData: [
        {
          id: 1,
          employee_name: "Muhammed Ali",
          date: "01 - 10 - 2018 ",
          clock_type: "Clock In",
          referenceCode: "#1g23k",
          time: "07:50:01",
          location: "2, TBS BRT, Lagos Island",
          status: "pending",
        },
        {
          id: 1,
          employee_name: "Nwela Blessing",
          date: "01 - 10 - 2018 ",
          clock_type: "Clock In",
          referenceCode: "#1g23k",
          time: "07:50:01",
          location: "2, TBS BRT, Lagos Island",
          status: "pending",
        },
        {
          id: 1,
          employee_name: "Nonso Okon",
          date: "01 - 10 - 2018 ",
          clock_type: "Clock In",
          referenceCode: "#1g23k",
          time: "07:50:01",
          location: "2, TBS BRT, Lagos Island",
          status: "approved",
        },
        {
          id: 1,
          employee_name: "Seun Alabi",
          date: "01 - 10 - 2018 ",
          clock_type: "Clock In",
          referenceCode: "#1g23k",
          time: "07:50:01",
          location: "2, TBS BRT, Lagos Island",
          status: "approved",
        },
        {
          id: 1,
          employee_name: "Bayo Kuku",
          date: "01 - 10 - 2018 ",
          clock_type: "Clock In",
          referenceCode: "#1g23k",
          time: "07:50:01",
          location: "2, TBS BRT, Lagos Island",
          status: "rejected",
        },
      ],
      tabLinks: [
        {
          label: "Approvals",
          url: "/ess/attendance/mobile-clocks/approvals",
        },
        {
          label: "My Logs",
          url: "/ess/attendance/mobile-clocks/my-logs",
        },
      ],
    };
  },
  components: {
    AllApprovalsLogsTable,
    Tabs,
  },
  methods: {
    search() {},
  },
};
</script>
